__turbopack_context__.v({
  "container": "ItemTile-module__Zm_Xma__container",
  "itemBlock": "ItemTile-module__Zm_Xma__itemBlock",
  "textContainer": "ItemTile-module__Zm_Xma__textContainer",
  "thumbnailContainer": "ItemTile-module__Zm_Xma__thumbnailContainer",
  "tileLink": "ItemTile-module__Zm_Xma__tileLink",
});
